module.exports = __webpack_public_path__ + "static/media/platinum_passportab432d0cd161be54cb32753dab918798.webp";